export default __webpack_public_path__ + "static/1-year-f9b914212678beaf6c1f95378dfac142.svg";